"use client";

import React from "react";
import { motion } from "framer-motion";
import { CircleCheck as CheckCircle2, Clock, MapPin, UserCheck } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
interface StepItem {
  number: string;
  icon: React.ElementType;
  text: string;
}
const steps: StepItem[] = [{
  number: "01",
  icon: Clock,
  text: "Wählen Sie Ihre Dauer"
}, {
  number: "02",
  icon: MapPin,
  text: "Nennen Sie uns Ihr Abholhotel und Ihre Wunschziele"
}, {
  number: "03",
  icon: UserCheck,
  text: "Ihr privater Fahrer steht Ihnen während der gebuchten Zeit zur Verfügung"
}, {
  number: "04",
  icon: CheckCircle2,
  text: "Kehren Sie zu Ihrem Hotel zurück oder beenden Sie die Fahrt an Ihrem Wunschort"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function HowItWorks() {
  return <section id="howitworks" data-nav="light" className="bg-background text-foreground py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-16 tracking-tight text-[#324A6D]">
          So funktioniert es
        </h2>

        <div className="relative">
          {/* Thin horizontal connector line behind cards on large screens */}
          <div className="hidden lg:block absolute top-1/2 left-8 right-8 h-px bg-border -translate-y-1/2 z-0" aria-hidden="true" />

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          amount: 0.2
        }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={step.number} variants={itemVariants} data-index={index}>
                  <Card className="h-full bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-6">
                    <div className="flex items-center justify-between">
                      <Badge variant="default" className="rounded-full px-3 py-1 font-mono text-xs font-semibold bg-[#D99000] text-white border-transparent">
                        {step.number}
                      </Badge>
                      <div className="p-2.5 rounded-xl bg-[#FCEBD0] text-[#D99000]">
                        <Icon className="size-5" aria-hidden="true" />
                      </div>
                    </div>
                    <p className="text-card-foreground font-medium text-base leading-snug">
                      {step.text}
                    </p>
                  </Card>
                </motion.div>;
          })}
          </motion.div>
        </div>
      </div>
    </section>;
}